import { Alert, Button, Icon, Input } from "@components";
import { ColorsEnum } from "@utilities/enums";
import { ErrorType } from "@utilities/types";
import { FC, useCallback, useState } from "react";

interface Props {
    isLoading: boolean 
    signinError: ErrorType | null 
    onSignIn: (email: string, password: string)=> void
    handleFirstTimeClick: ()=> void 
    handleForgotPasswordClick: ()=> void  
}

export const LoginForm:FC<Props> = ({ 
    isLoading,
    signinError,
    onSignIn,
    handleFirstTimeClick,
    handleForgotPasswordClick,
 })=> {

    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const handleSinIn = useCallback(()=> {
        if(!email || !password) return;

        onSignIn(email, password);
    }, [email, password, onSignIn]);

    return (
        <div className="p-1 items-center max-w-md mx-auto">
            <h2 className="text-2xl font-semibold text-center text-secondary mb-10">Connexion</h2>

            {
                signinError && (
                    <Alert
                        showCloseButton
                        type="error"
                        message={signinError.message}
                    />
                )
            }

            <div className="space-y-6">
                <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Mail"
                    className="input input-bordered rounded-full"
                    leftIcon={(
                        <Icon iconName="User"
                            color={ColorsEnum.PRIMARY}
                            size={25}
                        />
                    )}
                />
                <Input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Mot de passe"
                    className="input input-bordered rounded-full"
                    leftIcon={<Icon iconName="LockKeyhole"
                        color={ColorsEnum.PRIMARY}
                        size={25}
                    />}
                    rightIcon={(
                        <Icon
                            onPress={()=> setShowPassword(!showPassword)}
                            iconName={showPassword ? "EyeClosed" : "Eye"}
                            size={25}
                            color={ColorsEnum.SECONDARY}
                        />
                    )}
                />

                <div className="flex justify-between w-full text-sm text-primary">
                    <label
                        onClick={handleFirstTimeClick}
                        className="hover:text-primary-focus cursor-pointer"
                    >
                        Première fois ?
                    </label>
                    <label
                        onClick={handleForgotPasswordClick}
                        className="hover:text-primary-focus cursor-pointer"
                    >
                        Mot de passe oublié ?
                    </label>
                </div>

                <Button
                    className="w-full"
                    disabled={isLoading}
                    onClick={handleSinIn}
                >
                    {isLoading ? (
                        <span className="loading loading-spinner loading-sm"></span>
                    ) : (
                        "Me connecter"
                    )}
                </Button>
            </div>
        </div>
    )
}
